import { getStore } from 'cadenza/store/cadenza-store';
import {
  hasConditionsWithMissingMandatoryValue,
  hasMajorChange,
  isRepositoryPublishingProcessEnabled,
  isWorkbookPublished,
  isWorkbookSaved,
  isWorkbookWritable,
} from 'cadenza/workbook/workbook-core-selectors.state';

import i18n from './subscribe-utils.properties';

/**
 * Checks if subscribe to currently open worksheet is possible.
 * If not returns a reason to show to the user.
 *
 * @return An object with an "allowed" flag and a "reason" message in case the flag is `false`
 */
export function isSubscribeToWorksheetAllowed(): { allowed: boolean; reason: string } {
  if (hasConditionsWithMissingMandatoryValue(getStore().getState())) {
    return {
      allowed: false,
      reason: i18n('reasonDisallowed.mandatoryConditionValueMissing'),
    };
  } else if (!isWorkbookSaved(getStore().getState()) || hasMajorChange(getStore().getState())) {
    const tooltipMessageKey = `reasonDisallowed.hasMajorChange.${isWorkbookWritable(getStore().getState()) ? 'with' : 'without'}WritePrivilege`;
    return {
      allowed: false,
      reason: i18n(tooltipMessageKey),
    };
  } else if (
    isRepositoryPublishingProcessEnabled(getStore().getState()) &&
    !isWorkbookPublished(getStore().getState())
  ) {
    return {
      allowed: false,
      reason: i18n('reasonDisallowed.unpublished'),
    };
  } else {
    return {
      allowed: true,
      reason: '',
    };
  }
}
